const loadMoreClick = async (url, insertPosition) => {
  const spinner = document.querySelector('.load-more-btn .loading__spinner');
  spinner.classList.remove('hidden');
  const showErrorBanner = (parentNode) => {
    const bannerElement = document.createRange().createContextualFragment(`
      <div class="banner banner--error" role="alert">
        There was an error, please try again.
      </div>
    `).firstElementChild;
    parentNode.prepend(bannerElement);
    setTimeout(() => bannerElement.remove(), 2500);
  };
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const loadPrevBtn = document.querySelector('.load-prev-btn');

  try {
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const page = parser.parseFromString(html, 'text/html');
    const newProducts = page.querySelector('.grid.product-grid');
    const productsOnPage = document.querySelector('.grid.product-grid');
    productsOnPage.insertAdjacentHTML(insertPosition, newProducts.innerHTML);
    window.history.pushState({}, '', url);

    const nextUrl = newProducts.dataset.nextUrl;
    const prevUrl = newProducts.dataset.prevUrl;

    const existingValues = document.querySelector('.pagination-no-btn').innerText.match(/\d+/g);
    const newPaginationValues = page.querySelector('.pagination-no-btn').innerText.match(/\d+/g);

    let newPaginationString = '';
    const oldPaginationString = existingValues[0] + '-' + existingValues[1];
    if (insertPosition === 'afterbegin') {
      newPaginationString = newPaginationValues[0] + '-' + existingValues[1];
      productsOnPage.dataset.prevUrl = prevUrl;
    } else {
      newPaginationString = existingValues[0] + '-' + newPaginationValues[1];
      productsOnPage.dataset.nextUrl = nextUrl;
    }

    document.querySelector('.pagination-no-btn').innerHTML = document
      .querySelector('.pagination-no-btn')
      .innerHTML.replaceAll(oldPaginationString, newPaginationString);
    document.querySelector('#load-pagination').innerHTML = document
      .querySelector('#load-pagination')
      .innerHTML.replaceAll(oldPaginationString, newPaginationString);

    if (prevUrl === '' || parseInt(existingValues[0]) === 1) {
      loadPrevBtn.classList.add('hidden', true);
    } else {
      loadPrevBtn.classList.remove('hidden');
    }
    if (nextUrl === '' || parseInt(existingValues[1]) === parseInt(existingValues[2])) {
      loadMoreBtn.classList.add('hidden');
    } else {
      loadMoreBtn.classList.remove('hidden');
    }
  } catch (error) {
    showErrorBanner(loadMoreBtn.parentNode);
  } finally {
    spinner.classList.add('hidden');
  }
};

const loadMoreBindEventListeners = () => {
  const productsOnPage = document.querySelector('.grid.product-grid');
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const loadPrevBtn = document.querySelector('.load-prev-btn');
  let nextUrl = productsOnPage.dataset.nextUrl;
  let prevUrl = productsOnPage.dataset.prevUrl;

  loadPrevBtn.classList.toggle('hidden', !prevUrl);
  loadPrevBtn.classList.add('hidden-on-load', !prevUrl);
  loadMoreBtn.classList.toggle('hidden', !nextUrl);
  loadMoreBtn.classList.add('hidden-on-load', !nextUrl);
  loadMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const productsOnPage = document.querySelector('.grid.product-grid');
    loadMoreClick(productsOnPage.dataset.nextUrl, 'beforeend');
  });

  loadPrevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const productsOnPage = document.querySelector('.grid.product-grid');
    loadMoreClick(productsOnPage.dataset.prevUrl, 'afterbegin');
  });
};

document.addEventListener('DOMContentLoaded', () => {
  loadMoreBindEventListeners();
});
